import { COMMON } from '@/api'

/* Define Module Name */
// const MODULE_NAME = "common/";

/* Define Action Name */
const A_GET_COUNTRY_LIST = 'getCountryList'
const A_REQUEST_OTP = 'requestOTP'
const A_RESEND_OTP = 'resendOTP'
const A_VERIFY_OTP = 'verifyOTP'
const A_VERIFY_EMAIL = 'verifyEmail'
const A_VERIFY_REFERRAL = 'verifyReferralCode'
const A_GET_STORE_LIST = 'getStoreList'
const A_GET_STORE_DETAILS = 'getStoreDetails'
const A_RESET_PASSWORD = 'resetPassword'
const A_GET_LANGUAGE_LIST = 'getLanguageList'

/* Define Getter Name */
const G_COUNTRY_LIST = 'countryList'
const G_SG_COUNTRY_ID = 'SGCountryId'
const G_LANGUAGE_LIST = 'languageList'
const G_LANGUAGE_BY_ID = 'getLanguageById'

/* Define Mutation Name */
const M_SET_COUNTRY_LIST = 'setCountryList'
const M_SET_LANGUAGE_LIST = 'setLanguageList'
const M_SAVE_FORM = 'saveForm'
const M_SET_OTP_NUMBER = 'setOtpNumber'
const M_SET_OTP = 'setOtp'
const M_SET_STORE_LIST = 'setStoreList'
const M_SET_BRAND_LIST = 'setBrandList'

const state = {
  countryList: [],
  languageList: [],
  savedForm: {},
  otpPhoneNumber: '',
  storeList: [],
  brandList: [],
  otp: ''
}

//Getters
const getters = {
  [G_COUNTRY_LIST]: (state) => state.countryList,
  [G_SG_COUNTRY_ID]: (state) => state.countryList.findIndex((f) => f.abbreviation === 'SG') > -1 && state.countryList[state.countryList.findIndex((f) => f.abbreviation === 'SG')].id,
  [G_LANGUAGE_LIST]: (state) => state.languageList,
  [G_LANGUAGE_BY_ID]: (state) => (id) => {
    return state.languageList.find((language) => language.id === id)
  }
}

// Actions
const actions = {
  async [A_GET_COUNTRY_LIST]({ commit, state }) {
    if (state.countryList.length > 0) return
    await COMMON.countryList().then((response) => {
      let countryList = response.country.sort((a, b) => b.abbreviation.localeCompare(a.abbreviation))
      commit(M_SET_COUNTRY_LIST, countryList)
    })
  },
  async [A_GET_LANGUAGE_LIST]({ commit, state }) {
    if (state.languageList.length > 0) return
    await COMMON.getLanguageList().then((response) => {
      commit(M_SET_LANGUAGE_LIST, response.language)
    })
  },
  async [A_REQUEST_OTP]({ commit }, form) {
    commit(M_SAVE_FORM, form)
    commit(M_SET_OTP_NUMBER, `${form.mobileNumber.phone_code} ${form.mobileNumber.mobile}`)
    await COMMON.requestOTP(form)
  },

  async [A_RESEND_OTP]({ state }) {
    await COMMON.requestOTP(state.savedForm)
  },

  async [A_VERIFY_OTP]({ state, commit }, form) {
    commit(M_SET_OTP, form.otp)
    return await COMMON.verifyOTP({ ...state.savedForm, ...form })
  },

  async [A_VERIFY_EMAIL](_, form) {
    return await COMMON.verifyEmail(form)
  },

  async [A_VERIFY_REFERRAL](_, form) {
    return await COMMON.verifyReferralCode(form)
  },

  async [A_GET_STORE_LIST]({ commit }, data) {
    return await COMMON.getStoreList(data).then((response) => {
      commit(M_SET_STORE_LIST, response.store)
      commit(M_SET_BRAND_LIST, response.brand)
    })
  },

  async [A_RESET_PASSWORD]({ commit, state }, form) {
    return await COMMON.resetPassword({ ...state.savedForm, ...form, otp: state.otp })
  },

  /* 
    TODO: Request Cheng Hui for API that provides store list with rating and available stylist (with images) 
    current storedetails API needs to be queried one by one.
  */

  async [A_GET_STORE_DETAILS](_, data) {
    return await COMMON.getStoreDetails(data)
  }
}

// Mutations
const mutations = {
  [M_SET_COUNTRY_LIST]: (state, countryList) => {
    state.countryList = countryList
  },
  [M_SET_LANGUAGE_LIST]: (state, languageList) => {
    state.languageList = languageList
  },
  [M_SAVE_FORM]: (state, form) => {
    state.savedForm = { ...state.savedForm, ...form }
  },
  [M_SET_OTP_NUMBER]: (state, number) => {
    state.otpPhoneNumber = number
  },
  [M_SET_OTP]: (state, number) => {
    state.otp = number
  },
  [M_SET_STORE_LIST]: (state, storeList) => {
    state.storeList = storeList
  },
  [M_SET_BRAND_LIST]: (state, brandList) => {
    state.brandList = brandList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
